import retailerContext from "@modern/services/retailer_context";
import userContext from "@modern/services/user_context";
import { initializeStateService } from "@modern/services/boot/state_service";
import shimRootScope from "@modern/services/angularjs_shims/rootScope";
import cartService from "@modern/services/cart";
import setupDeviceSize from "./device_size";
import messagesContext from "@modern/services/messages_context";
import initSentry from "@modern/services/boot/sentry";
import initStatsig from "@modern/services/boot/statsig";
import SalesforceChat from "@shared/services/salesforce_chat";
import { setMenuItems } from "@modern/services/menus";
import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";

const setupSvelteModal = function () {
  window["svelteModal"] = function (component, props) {
    new component({
      target: document.getElementById("programmatic-modal-container"),
      props: props,
    });
  };
};

const bootstrap = async function (routifyCommands) {
  initSentry();
  shimRootScope();
  setupDeviceSize(window["$rootScope"]);
  initializeStateService(routifyCommands);
  setupSvelteModal();

  if (window["C"].APP_NAME == "retailer") {
    await retailerContext.initialize(null);
    DistributorsStore.fetchDistributors();
  }

  if (window["C"].APP_NAME === "retailer" || window["C"].APP_NAME === "demo") {
    setMenuItems(window["C"].APP_NAME);
  }

  let userRes;
  if (!(window["C"].APP_NAME === "no_auth_app")) {
    userRes = await userContext.initialize();
    if (!userRes) {
      return false;
    }
  }

  initStatsig();

  if (window["C"].APP_NAME == "retailer") {
    await messagesContext.initialize();
    if (window.location.pathname !== "/cart") {
      await cartService.initialize();
    }
  } else if (window["C"].APP_NAME === "no_auth_app") {
    console.log("NO AUTH APP");
  }

  if (window["C"].APP_NAME !== "demo") {
    SalesforceChat.initialize();
  }
  return true;
};

export default bootstrap;
